'use strict';

require('../../style/index.less');

require('./index.less');

require('./button-switch.less');


/*****************
 ** WEBPACK FOOTER
 ** ./components/switch/style/index.js
 ** module id = 236
 ** module chunks = 0
 **/